import FormControl from '@mui/material/FormControl';
import { ErrorMessage, Field } from 'formik';
import FormHelperText from '@mui/material/FormHelperText';
import { CheckboxWithLabel } from 'formik-mui';
import Link from '@mui/material/Link';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Label from '../Label';

const PolicyLinkList = styled.ul`
  margin-top: 0;
`;

PrivacyAcknowledgementField.propTypes = {
  touched: PropTypes.any,
  privacyAcknowledgement: PropTypes.any,
  errors: PropTypes.any,
};

function PrivacyAcknowledgementField({ errors, privacyAcknowledgement, touched }) {
  return (
    <FormControl
      variant='standard'
      margin='dense'
      fullWidth
      error={touched.privacyAcknowledgements?.[privacyAcknowledgement.id] &&
      errors.privacyAcknowledgements?.[privacyAcknowledgement.id]}
    >
      <ErrorMessage
        name={`privacyAcknowledgements.${privacyAcknowledgement.id}`}
        component={FormHelperText}
      />
      <Field
        color='secondary'
        component={CheckboxWithLabel}
        type='checkbox'
        name={`privacyAcknowledgements.${privacyAcknowledgement.id}`}
        Label={{ label: <Label as='span'>{privacyAcknowledgement.statement}</Label> }}
      />
      {(privacyAcknowledgement.policyLinks || []).length > 0 && (
        <PolicyLinkList>
          {privacyAcknowledgement.policyLinks.map((policyLink, index) => (
            <li key={index}>
              <Link
                href={policyLink.url}
                target='_blank'
                rel='noopener'
                color='secondary'
                underline="hover"
              >
                {policyLink.name}
              </Link>{' '}
              {(policyLink.version || privacyAcknowledgement.version) && (
                <small>({policyLink.version || privacyAcknowledgement.version})</small>
              )}
            </li>
          ))}
        </PolicyLinkList>
      )}
    </FormControl>
  );
}

export default PrivacyAcknowledgementField;
